var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26693(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26693",
    "data-name": "Group 26693",
    transform: "translate(-516 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(516 788)",
    fill: "#fb7b18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23251",
    "data-name": "Path 23251",
    d: "M395.219,89.98a18.647,18.647,0,0,1,9.5-21.14,22.586,22.586,0,0,1,4.609,5.623,25.473,25.473,0,0,0-14.1,15.517m6.088,9.8A18.824,18.824,0,0,1,396.6,93.75a23.412,23.412,0,0,1,13.793-17.191,22.788,22.788,0,0,1,1.848,8.2,24.328,24.328,0,0,0-10.935,15.018m19.8-.264a27.125,27.125,0,0,0,5.3-.561,18.671,18.671,0,0,1-13.006,5.262,19.056,19.056,0,0,1-10.108-2.929,22.3,22.3,0,0,1,2.567-6.795,26.433,26.433,0,0,0,15.243,5.023M414.594,84.8a24.323,24.323,0,0,0-7.535-16.979,18.676,18.676,0,0,1,6.347-1.126c.411,0,.812.036,1.217.062a23.59,23.59,0,0,1,8.171,17.779,20.663,20.663,0,0,1-.177,2.759,21.519,21.519,0,0,1-8.023-2.494m10.42,4.978a24.553,24.553,0,0,0,6.836-.991,18.651,18.651,0,0,1-2.837,7.069,25.567,25.567,0,0,1-7.921,1.3A23.033,23.033,0,0,1,407.2,92.516a21.479,21.479,0,0,1,6.18-5.706,24.028,24.028,0,0,0,11.629,2.968m7.152-4.323c0,.264-.029.521-.041.783A22.348,22.348,0,0,1,425,87.41h-.04a23.431,23.431,0,0,0,.167-2.83,25.7,25.7,0,0,0-6.558-17.147,18.751,18.751,0,0,1,13.593,18.021",
    transform: "translate(138.353 738.305)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26693);
export default __webpack_public_path__ + "static/media/Group 26693.14d1449b1b6f542d190e0c074f4db7aa.svg";
export { ForwardRef as ReactComponent };